import React, {useEffect, useMemo, useState} from 'react'
import axios from 'axios'
import LoadingOverlay from 'react-loading-overlay'
import {AdminDataTable, AdminTableSearch} from '../../components/AdminDataTable/AdminDataTable'
import {OrderDetail} from '../../components/OrderDetail/OrderDetail'
import '../Pedidos/Pedidos.css'
import '../MisPedidos/MisPedidos.css'

const money = new Intl.NumberFormat('es-MX', {style: 'currency', currency: 'MXN'})
const dateTime = new Intl.DateTimeFormat('es-MX', {dateStyle: 'medium', timeStyle: 'short'})
const initialFilters = {distribuidor: '', fecha_inicial: '', fecha_final: ''}

function PedidosVendedor() {
  const API_URL = process.env.REACT_APP_API_URL
  const [orders, setOrders] = useState([])
  const [detail, setDetail] = useState(null)
  const [filters, setFilters] = useState(initialFilters)
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const loadOrders = async (activeFilters = filters) => {
    setLoading(true); setError('')
    try {
      const {data} = await axios.get(`${API_URL}/pedidos-vendedor`, {params: activeFilters})
      setOrders(data.data || [])
    } catch (requestError) {
      setError(requestError.response?.data?.message || 'No fue posible consultar tus pedidos.')
    } finally { setLoading(false) }
  }

  useEffect(() => {
    loadOrders(initialFilters)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const viewOrder = async (id) => {
    setLoading(true); setError('')
    try {
      const {data} = await axios.get(`${API_URL}/pedidos-vendedor/${id}`)
      setDetail(data.data)
    } catch (requestError) {
      setError(requestError.response?.data?.message || 'No fue posible consultar el pedido.')
    } finally { setLoading(false) }
  }

  const visibleOrders = useMemo(() => {
    const term = search.trim().toLocaleLowerCase('es-MX')
    if (!term) return orders
    return orders.filter((order) => `${order.folio} ${order.distribuidor} ${order.nombreComercial}`.toLocaleLowerCase('es-MX').includes(term))
  }, [orders, search])

  const columns = [
    {name: 'Folio', selector: (row) => row.folio, sortable: true, cell: (row) => <strong className='pedido-folio'>{row.folio}</strong>},
    {id: 'fecha', name: 'Fecha', selector: (row) => new Date(row.fecha.replace(' ', 'T')).getTime(), sortable: true, cell: (row) => dateTime.format(new Date(row.fecha.replace(' ', 'T'))), grow: 1.3},
    {name: 'Distribuidor', selector: (row) => row.distribuidor, sortable: true, grow: 1.3},
    {name: 'Productos', selector: (row) => Number(row.productos), sortable: true, center: true},
    {name: 'Total', selector: (row) => Number(row.total), sortable: true, right: true, cell: (row) => <strong>{money.format(row.total)}</strong>},
    {name: 'Acción', button: true, cell: (row) => <button type='button' className='btn btn-sm btn-light-primary' onClick={() => viewOrder(row.id)}>Ver</button>},
  ]

  return <LoadingOverlay active={loading} spinner text='Cargando...'>
    <OrderDetail detail={detail} onHide={() => setDetail(null)} />
    <div className='card card-custom card-stretch shadow mb-5 admin-list-card mis-pedidos-card'><div className='card-header'><h3 className='card-title'>Mis Pedidos</h3></div><div className='card-body'>
      <form className='pedido-filters' onSubmit={(event) => {event.preventDefault(); loadOrders()}}>
        <input className='form-control' placeholder='Distribuidor' value={filters.distribuidor} onChange={(event) => setFilters({...filters, distribuidor: event.target.value})} />
        <input className='form-control' type='date' aria-label='Fecha inicial' value={filters.fecha_inicial} onChange={(event) => setFilters({...filters, fecha_inicial: event.target.value})} />
        <input className='form-control' type='date' aria-label='Fecha final' value={filters.fecha_final} onChange={(event) => setFilters({...filters, fecha_final: event.target.value})} />
        <button className='btn btn-primary' type='submit'>Filtrar</button><button className='btn btn-light' type='button' onClick={() => {setFilters(initialFilters); loadOrders(initialFilters)}}>Limpiar</button>
      </form>
      {error && <div className='alert alert-danger'>{error}</div>}
      <AdminTableSearch value={search} onChange={(event) => setSearch(event.target.value)} ariaLabel='Buscar pedidos' placeholder='Buscar por folio, distribuidor o nombre comercial...' />
      <AdminDataTable columns={columns} data={visibleOrders} pagination paginationPerPage={10} paginationRowsPerPageOptions={[10, 25, 50, 100]} defaultSortFieldId='fecha' defaultSortAsc={false} noDataComponent={<div className='mis-pedidos-empty'><strong>No hay pedidos para mostrar.</strong><span>Prueba con otros filtros.</span></div>} />
    </div></div>
  </LoadingOverlay>
}

export {PedidosVendedor}
